export const loadState = (key = 'nlu') => {
  try {
    const serializedState = localStorage.getItem(key);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (value, key = 'nlu') => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    throw err;
  }
};

export const removeState = (key = 'nlu') => {
  localStorage.removeItem(key);
};
